import React from "react";
import { Link } from "@quintype/components";
import get from "lodash/get";
import { string, object, bool } from "prop-types";

import SponsoredIcon from "../../atoms/icons/Sponsored";

import "./newsHeadline.m.css";

const NewsHeadline = ({
  titleText = "",
  titleLink = "",
  subHeadlineText = "",
  cssStyleName,
  sectionData,
  showSectionTag,
  datatrackingcategory = "",
  datatrackingaction = "",
  datatrackinglabel = "",
  currentStoryTitleColor = "",
  story = {},
  showDot = false,
  styles = {},
  showSubHeading = true,
}) => {
  const sponsorId = get(story, ["metadata", "story-attributes", "sponsoredby", "0", "id"], null);
  return (
    <h2 styleName={`title ${cssStyleName}`} className="headline-title" style={{ color: currentStoryTitleColor }}>
      {showDot && styles && (
        <span styleName="s-dot" style={{ background: styles.dotColor.color !== "4d" ? styles.dotColor.color : "#ccc" }}>
          &nbsp;
        </span>
      )}

      {sponsorId && <SponsoredIcon />}
      {showSectionTag && sectionData.link === "/video" ? (
        <>
          <Link href={sectionData.link}>
            <span styleName="sub-title with-link">{sectionData.name}</span>
          </Link>
          <Link href={titleLink} styleName="title-link">
            {titleText}
          </Link>
        </>
      ) : (
        <Link
          href={titleLink}
          styleName="title-link"
          data-tracking-category={datatrackingcategory}
          data-tracking-action={datatrackingaction}
          data-tracking-label={datatrackinglabel}
        >
          {showSubHeading && subHeadlineText && <span styleName="sub-title no-link">{subHeadlineText}</span>}

          {titleText}
        </Link>
      )}
    </h2>
  );
};

NewsHeadline.propTypes = {
  titleText: string,
  titleLink: string,
  subHeadlineText: string,
  cssStyleName: string,
  sectionData: object,
  showSectionTag: bool,
  datatrackingcategory: string,
  datatrackingaction: string,
  datatrackinglabel: string,
  currentStoryTitleColor: string,
  story: object,
  showDot: bool,
  styles: object,
  showSubHeading: bool,
};

export default NewsHeadline;
